import type { Branding } from '@/shared/api/types';

/**
 * Aplica a identidade visual da empresa em tempo de execucao.
 *
 * A personalizacao acontece por variaveis CSS, e nao por um build por cliente.
 * Uma empresa nova entra sem nenhuma alteracao de codigo, e a troca de cor tem
 * efeito imediato. Ver docs/WHITE_LABEL.md.
 */

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

export function applyBranding(branding: Branding | null): void {
  const root = document.documentElement;

  if (!branding) {
    resetBranding();
    return;
  }

  setColor(root, '--tenant-primary', branding.primary_color);
  setColor(root, '--tenant-accent', branding.accent_color);
  setColor(root, '--tenant-theme', branding.theme_color);
  setColor(root, '--tenant-background', branding.background_color);

  if (HEX_COLOR.test(branding.theme_color)) {
    setMetaContent('theme-color', branding.theme_color);
  }

  const title = branding.pwa_name || branding.display_name;
  if (title) {
    document.title = title;
  }

  if (branding.favicon_url) {
    setFavicon(branding.favicon_url);
  }
}

export function resetBranding(): void {
  const root = document.documentElement;
  for (const token of [
    '--tenant-primary',
    '--tenant-accent',
    '--tenant-theme',
    '--tenant-background',
  ]) {
    root.style.removeProperty(token);
  }
}

/**
 * Escreve a variavel apenas quando o valor tem formato conhecido.
 *
 * O valor vem do servidor, mas passa por aqui antes de virar CSS. Um valor
 * arbitrario escrito direto em uma propriedade customizada e um vetor de
 * injecao de estilo.
 */
function setColor(root: HTMLElement, token: string, value: string): void {
  if (HEX_COLOR.test(value)) {
    root.style.setProperty(token, value);
  } else {
    root.style.removeProperty(token);
  }
}

function setMetaContent(name: string, content: string): void {
  let meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}

function setFavicon(href: string): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}
